module.exports = __webpack_public_path__ + "img/zj@2x.171fdfbe.png";